<button mat-flat-button class="gray" (click)="openCreateUserDialog('300ms', '100ms')">
    Launch Dialog
</button>